<template>
  <div class="doctorIP">
    <div class="ipbox">
      <titleCard title="'Self-Media' Brands Operation"></titleCard>
      <div class="title-text">
        From digital advertising to self-media matrices, to the infrastructure
        needed to build e-commerce, and to provide more value through
        high-quality Health Content and Patient Education Solutions.
      </div>
      <div class="PC-box">
        <div class="brief-box">
          <div class="box-img animate__animated wow animate__fadeInLeft">
            <video
              width="100%"
              height="100%"
              controls
              ref="video"
              autoplay="autoplay"
              v-if="video1IsShow"
            >
              <source
                src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/video/5c7e628b-1811dc3f93c.mp4"
                type="video/mp4"
              />
              <source src="movie.ogg" type="video/ogg" />
              您的浏览器不支持Video标签。
            </video>
            <div class="cover" v-else>
              <img src="../../assets/image/innovatc/video1.jpg" alt="" />
              <div class="btn" @click="AutoPlay(1)"></div>
            </div>
          </div>
          <div class="box-txt animate__animated wow animate__fadeInRight">
            <h2>01</h2>
            <h3>Health Content and Patient Education Solutions</h3>
            <p>
              professional creative team to make the difficult medical terms and
              knowledges easy to understand.medical terms and knowledges easy to
              understand.
            </p>
          </div>
        </div>
        <div class="brief-box">
          <div
            class="box-txt boxstyle animate__animated wow animate__fadeInLeft"
          >
            <h2>02</h2>
            <h3>Video production</h3>
            <p>
              Videos of health education, videos of academic promotion.A
              creative production team we offer a full service video production
              solution including strategy, creative, production, post
              production, photography and graphic design.
            </p>
          </div>
          <div class="box-img animate__animated wow animate__fadeInRight">
            <video
              width="100%"
              height="100%"
              controls
              ref="video"
              autoplay="autoplay"
              v-if="video2IsShow"
            >
              <source
                src="https://gyycvod.yythealth.com/aa8496d771e342839c250da932fffd6c/864cb0c50b78404cb13480c747dc9471-277debec9add8b7dbf5dd9843f918ac6-ld.mp4"
                type="video/mp4"
              />
              <source src="movie.ogg" type="video/ogg" />
              您的浏览器不支持Video标签。
            </video>
            <div class="cover" v-else>
              <img src="../../assets/image/innovatc/video2.png" alt="" />
              <div class="btn" @click="AutoPlay(2)"></div>
            </div>
          </div>
        </div>
        <div class="brief-box">
          <div class="box-img animate__animated wow animate__fadeInLeft">
            <img src="../../assets/image/innovatc/doctor2.webp" />
          </div>
          <div class="box-txt animate__animated wow animate__fadeInRight">
            <h2>03</h2>
            <h3>Live Stream</h3>
            <p>
              Science Popularization Lectures, Academic Lectures, live stream on
              e-commerce platform.
            </p>
          </div>
        </div>
        <div class="brief-box">
          <div
            class="box-txt boxstyle animate__animated wow animate__fadeInLeft"
          >
            <h2>04</h2>
            <h3>Media Matrix Marketing</h3>
            <p>
              Manage and plan the company's own media channels, including the
              Wechat account, official website and other self-media platform
              content.
            </p>
          </div>
          <div class="box-img animate__animated wow animate__fadeInRight">
            <img src="../../assets/image/innovatc/doctor3.webp" />
          </div>
        </div>
      </div>
      <div class="IOS-box">
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <video
              width="100%"
              height="100%"
              controls
              ref="video"
              autoplay
              v-if="videoIos1IsShow"
            >
              <source
                src="https://gyycvod.yythealth.com/aa8496d771e342839c250da932fffd6c/864cb0c50b78404cb13480c747dc9471-277debec9add8b7dbf5dd9843f918ac6-ld.mp4"
                type="video/mp4"
              />
              <source src="movie.ogg" type="video/ogg" />
              您的浏览器不支持Video标签。
            </video>
            <div class="cover" v-else>
              <img src="../../assets/image/innovatc/video1.jpg" alt="" />
              <div class="btn" @click="AutoPlay2(1)"></div>
            </div>
          </div>
          <div class="txt">
            <div class="left">
              <h2>01</h2>
            </div>
            <div class="right">
              <h3>Health Content and Patient Education Solutions</h3>
              <p>
                professional creative team to make the difficult medical terms
                and knowledges easy to understand.medical terms and knowledges
                easy to understand.
              </p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <video
              width="100%"
              height="100%"
              controls
              ref="video"
              autoplay
              v-if="videoIos2IsShow"
            >
              <source
                src="https://gyycvod.yythealth.com/aa8496d771e342839c250da932fffd6c/864cb0c50b78404cb13480c747dc9471-277debec9add8b7dbf5dd9843f918ac6-ld.mp4"
                type="video/mp4"
              />
              <source src="movie.ogg" type="video/ogg" />
              您的浏览器不支持Video标签。
            </video>
            <div class="cover" v-else>
              <img src="../../assets/image/innovatc/video2.png" alt="" />
              <div class="btn" @click="AutoPlay2(2)"></div>
            </div>
          </div>
          <div class="txt">
            <div class="left">
              <h2>02</h2>
            </div>
            <div class="right">
              <h3>Video production</h3>
              <p>
                Videos of health education, videos of academic promotion.A
                creative production team we offer a full service video
                production solution including strategy, creative, production,
                post production, photography and graphic design.
              </p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="../../assets/image/innovatc/doctor2.webp" />
          </div>
          <div class="txt">
            <div class="left">
              <h2>03</h2>
            </div>
            <div class="right">
              <h3>Live Stream</h3>
              <p>
                Science Popularization Lectures, Academic Lectures, live stream
                on e-commerce platform.
              </p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="../../assets/image/innovatc/doctor3.webp" />
          </div>
          <div class="txt">
            <div class="left">
              <h2>04</h2>
            </div>
            <div class="right">
              <h3>Media Matrix Marketing</h3>
              <p>
                Manage and plan the company's own media channels, including the
                Wechat account, official website and other self-media platform
                content.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="youzhi animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard title="The Example"></titleCard>
      </div>
      <div class="youzhi-box">
        <el-carousel
          class="PClunbo"
          arrow="always"
          :autoplay="false"
          trigger="click"
        >
          <el-carousel-item v-for="(item, index) in lunboList" :key="index">
            <div class="lunbo-box">
              <div class="box-text">
                <div class="textbox">
                  <h4>{{ item.txt.name }}</h4>
                  <p
                    v-for="(item, index) in item.txt.title"
                    :title="item"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </div>
                <div class="textbox" style="padding-top: 0.3053rem">
                  <h4>Cooperative projects</h4>
                  <p>Doctor's personal number:</p>
                  <p
                    v-for="(item, index) in item.txt.account"
                    :title="item"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
              <div class="box-img">
                <img :src="item.pic" />
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="IOSlunbo">
          <div class="swiper mySwiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in lunboList"
                :key="index"
              >
                <div class="lunbo-box">
                  <div class="box-text">
                    <div class="textbox">
                      <h4>{{ item.txt.name }}</h4>
                      <p v-for="(item, index) in item.txt.title" :key="index">
                        {{ item }}
                      </p>
                    </div>
                    <div class="textbox" style="padding-top: 0.3053rem">
                      <h4>合作项目</h4>
                      <p>医生个人号：</p>
                      <p v-for="(item, index) in item.txt.account" :key="index">
                        {{ item }}
                      </p>
                    </div>
                  </div>
                  <div class="box-img">
                    <img :src="item.pic" />
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <footerCard name="Mr Wu" phone="138-1097-5144"></footerCard>
  </div>
</template>

<script>
import footerCard from "../../components/footer-card.vue";
import titleCard from "../../components/title-card.vue";
import Swiper from "swiper"; // 局部引入swiper
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";
export default {
  data() {
    return {
      address: "https://gyycvod.yythealth.com",
      lunboList: [
        {
          pic: require("../../assets/image/innovatc/lunbo3/IP-zl.png"),
          txt: {
            name: "Zuo Li",
            title: [
              "Director of Nephrology Department of Peking University People's Hospital",
              "Vice chairman of the nephrology special committee of the capacity building and continuing education center of the National Health Commission",
              "Chairman of the Management Branch of blood purification center of China Hospital Association",
              "Chairman of the blood purification Professional Committee of the Chinese Research Hospital Association",
              "Deputy editor in chief of China blood purification magazine",
            ],
            account: [" 微博：左力医生", "头条：北大人民左力", "健康界：左力"],
          },
        },
        {
          pic: require("../../assets/image/innovatc/lunbo3/IP-sz.webp"),
          txt: {
            name: "Sui Zhun",
            title: [
              "Deputy director of the Department of internal medicine, Peking University People's Hospital",
              "1 national patent (first applicant)",
              "Presided over and participated in more than 10 national, provincial, ministerial and academy level scientific research projects",
              "Participated in 2 international and domestic multicenter clinical studies",
              "Participated in the compilation and translation of 9 monographs and textbooks",
              "He has published more than 10 papers in professional magazines at home and abroad",
            ],
            account: [
              "微博：北大人民医院_隋准",
              "头条：隋准",
              "抖音:隋准",
              "百度健康:肾内科隋准医生",
            ],
          },
        },
        {
          pic: require("../../assets/image/innovatc/lunbo3/IP-zhp.webp"),
          txt: {
            name: "Zhao Huiping",
            title: [
              "Chief physician of Nephrology Department of Peking University People's Hospital",
              "Vice chairman of peritoneal dialysis Expert Committee of Beijing Medical Award Foundation",
              "Standing member of the blood purification Professional Committee of the Chinese Research Hospital Association",
              "Expert group member of Beijing blood purification quality control center",
              "Medical expert of peritoneal dialysis expert group of blood purification branch of Beijing Medical Association",
            ],
            account: ["微博：赵慧萍医生", "头条：赵慧萍"],
          },
        },
        {
          pic: require("../../assets/image/innovatc/lunbo3/IP-gly.webp"),
          txt: {
            name: "Gan Liangying",
            title: [
              "Chief physician of Nephrology Department of Peking University People's Hospital",
              "Head of Youth Committee of Management Branch of blood purification center of China Hospital Association",
              "Standing member of the technical committee of blood purification equipment of China Medical Equipment Association",
              "Executive director of Zhongguancun blood purification diagnosis and treatment technology innovation alliance",
              "Vice chairman of Xicheng District blood purification quality control and Improvement Center of Beijing Municipality",
            ],
            account: ["微博：甘良英医生", "头条：甘良英"],
          },
        },
      ],
      video1IsShow: false,
      video2IsShow: false,
      videoIos1IsShow: false,
      videoIos2IsShow: false,
    };
  },
  components: {
    footerCard,
    titleCard,
  },
  created() {},
  mounted() {
    new Swiper(".mySwiper", {
      spaceBetween: 30,
      pagination: ".swiper-pagination",
    });
  },
  methods: {
    AutoPlay(id) {
      if (id == 1) {
        this.video1IsShow = true;
        this.video2IsShow = false;
      } else {
        this.video2IsShow = true;
        this.video1IsShow = false;
      }
    },
    AutoPlay2(id) {
      if (id == 1) {
        this.videoIos1IsShow = true;
        this.videoIos2IsShow = false;
      } else {
        this.videoIos2IsShow = true;
        this.videoIos1IsShow = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.doctorIP {
  .ipbox {
    padding: 1.3684rem 0 1.5789rem 0;
    .title-text {
      color: #272b2d;
      font-size: 0.2526rem;
      text-align: center;
      padding: 0 2rem;
      padding-top: 0.5263rem;

      @media screen and (max-width: 540px) {
        padding: 30px 15px;
        font-size: 14px;
        line-height: 25px;
      }
    }
    .PC-box {
      .brief-box {
        @media screen and (max-width: 540px) {
          display: none;
        }
        padding-top: 1.0526rem;
        display: flex;
        height: 5.8421rem;
        .box-img {
          width: 50%;
          img {
            width: 100%;
            height: 100%;
          }
          .cover {
            width: 100%;
            height: 100%;
            position: relative;
            .btn {
              position: absolute;
              background: url("../../assets/image/innovatc/play.png") no-repeat;
              background-size: 100% 100%;
              width: 1.0526rem;
              height: 1.0526rem;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              cursor: pointer;
            }
          }
        }
        .boxstyle {
          padding-left: 2.5263rem !important;
        }
        .box-txt {
          width: 50%;
          box-sizing: border-box;
          padding-left: 1.5789rem;

          h2 {
            padding-top: 1rem;
            margin: 0;
            color: #0ca6eb;
            font-size: 0.8421rem;
            font-weight: 700;
            position: relative;
          }
          h2::after {
            position: absolute;
            left: 0;
            bottom: 0;
            content: "";
            width: 0.2105rem;
            height: 0.0526rem;
            background-color: #0ca6eb;
          }
          h3 {
            margin: 0;
            padding: 0.3895rem 0 0.5053rem 0;
            color: #000000;
            font-size: 0.4211rem;
            padding-right: 100px;
          }
          p {
            color: #333333;
            line-height: 0.4211rem;
            font-size: 0.2526rem;
            padding-right: 100px;
          }
        }
      }
    }
    .IOS-box {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .box {
        padding: 0 15px;
        padding-top: 48px;
        .pic {
          width: 100%;
          height: 223px;
          img {
            width: 100%;
            height: 100%;
          }
          .cover {
            width: 100%;
            height: 100%;
            position: relative;
            .btn {
              position: absolute;
              background: url("../../assets/image/innovatc/play.png") no-repeat;
              background-size: 100% 100%;
              width: 50px;
              height: 50px;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              cursor: pointer;
            }
          }
        }
        .txt {
          padding-top: 15px;
          display: flex;
          .left {
            padding-right: 11px;
            h2 {
              position: relative;
              color: #0ca6eb;
              font-size: 30px;
              margin: 0;
            }
            h2::after {
              position: absolute;
              left: 9px;
              bottom: -2px;
              content: "";
              width: 18px;
              height: 3px;
              background-color: #0ca6eb;
            }
          }
          .right {
            flex-wrap: wrap;
            h3 {
              color: #000;
              font-size: 16px;
              margin: 0;
              padding-top: 8px;
              margin-bottom: 10px;
            }
            p {
              color: #333;
              font-size: 14px;
              padding-right: 15px;
            }
          }
        }
      }
    }
  }
  .youzhi {
    .title {
      margin-bottom: 1.3684rem;
      @media screen and (max-width: 540px) {
        margin-bottom: 50px;
      }
    }
    .youzhi-box {
      height: 7.0526rem;
      margin: 0 auto;
      margin-bottom: 1.7684rem;
      @media screen and (max-width: 540px) {
        height: 440px;
      }
      .PClunbo {
        @media screen and (max-width: 540px) {
          display: none;
        }
        .lunbo-box {
          padding: 0.6842rem 1.0526rem;
          display: flex;
          justify-content: space-between;
          @media screen and (max-width: 540px) {
            height: 100%;
            position: relative;
            display: block;
          }
          .box-img {
            width: 5.0105rem;
            height: 100%;
            @media screen and (max-width: 540px) {
              position: absolute;
              right: 10px;
              bottom: 40px;
              width: 152px;
              height: 150px;
            }
          }
          .box-text {
            @media screen and (max-width: 540px) {
              height: 100%;
            }
            .textbox {
              @media screen and (max-width: 540px) {
                line-height: 30px;
              }
              h4 {
                font-size: 0.2947rem;
                color: #334046;
                margin-top: 0;
                position: relative;
              }
              h4::after {
                content: "";
                position: absolute;
                bottom: -0.1105rem;
                left: 0;
                width: 0.2316rem;
                height: 0.0526rem;
                background-color: #0ca6eb;
                @media screen and (max-width: 540px) {
                  width: 10px;
                  height: 2px;
                  bottom: 0;
                  font-size: 12px;
                }
              }
              p {
                color: #6a7073;
                line-height: 0.4rem;
                font-size: 0.2211rem;
                font-weight: 300;
                @media screen and (max-width: 540px) {
                  line-height: 18px;
                  font-size: 12px;
                }
              }
            }
          }
        }
        /deep/.el-carousel__container {
          height: 7.0526rem;
          margin: 0 auto;
          width: 12.8421rem;
          box-shadow: 0px 0px 31px 0px rgba(0, 0, 0, 0.04);
          margin-bottom: 1.7684rem;
          @media screen and (max-width: 540px) {
            width: 82%;
            height: 320px;
          }
          .el-carousel__arrow--right {
            right: -1.0526rem;
            @media screen and (max-width: 540px) {
              right: -35px;
            }
          }
          .el-carousel__arrow--left {
            left: -1.0526rem;
            @media screen and (max-width: 540px) {
              left: -35px;
            }
          }
        }
        /deep/ .el-carousel__arrow {
          width: 0.5263rem;
          height: 0.5263rem;
          background-color: #fff;
          border: 2px solid #c6c6c6;
          @media screen and (max-width: 540px) {
            width: 28px;
            height: 28px;
          }
          i {
            font-size: 0.2105rem;
            font-weight: 700;
          }
          color: #c6c6c6;
        }
        /deep/ .el-carousel__indicators--horizontal {
          bottom: 0.9474rem;
          @media screen and (max-width: 540px) {
            bottom: 0;
          }
        }

        /deep/ .el-carousel__button {
          height: 0.0842rem;
          background-color: #e8e8e8;
          @media screen and (max-width: 540px) {
            height: 5px;
          }
        }
        /deep/ .el-carousel__indicator.is-active button {
          background-color: #0ca6eb;
        }
        .el-carousel__item img {
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
      }
      .IOSlunbo {
        display: none;
        .swiper {
          padding-bottom: 50px;
          position: relative;
        }
        /deep/ .swiper-pagination-bullet {
          width: 11px !important;
          height: 11px !important;
        }
        .lunbo-box {
          padding: 0.6842rem 1.0526rem;
          display: flex;
          justify-content: space-between;
          @media screen and (max-width: 540px) {
            height: 100%;
            position: relative;
            display: block;
          }
          .box-img {
            width: 5.0105rem;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
            }
            @media screen and (max-width: 540px) {
              position: absolute;
              right: 10px;
              bottom: 0px;
              width: 122px;
              height: 120px;
            }
          }
          .box-text {
            @media screen and (max-width: 540px) {
              height: 100%;
            }
            .textbox {
              @media screen and (max-width: 540px) {
                line-height: 30px;
              }
              h4 {
                font-size: 0.2947rem;
                color: #334046;
                margin-top: 0;
                position: relative;
              }
              h4::after {
                content: "";
                position: absolute;
                bottom: -0.1105rem;
                left: 0;
                width: 0.2316rem;
                height: 0.0526rem;
                background-color: #0ca6eb;
                @media screen and (max-width: 540px) {
                  width: 10px;
                  height: 2px;
                  bottom: 0;
                  font-size: 12px;
                }
              }
              p {
                color: #6a7073;
                line-height: 0.4rem;
                font-size: 0.2211rem;
                font-weight: 300;
                @media screen and (max-width: 540px) {
                  line-height: 18px;
                  font-size: 12px;
                }
              }
            }
          }
        }
        @media screen and (max-width: 540px) {
          display: block;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
